<managed-list
    [legend]="'Challenge Content Hold'"
    [fields]="fields"
    [type]="'challenge-content-hold'"
    [fbFields]="properties"
    submitURL="challenge-content-hold"
></managed-list>
